module.exports = __webpack_public_path__ + "static/img/two_990gaodeng1.8e25e77.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ggw_img/two_990gaodeng1.png
// module id = t+5J
// module chunks = 36